import React from "react";
import { FilterInput } from "../FilterInput";
import { FilterSelector } from "../FilterSelector";
import { filterIds, growthAnalysisIncDecTimeFrame, producerOptions, searchfilterStateId as sfState, terms } from "../../../constants/suggestedAgents";
import PropTypes from 'prop-types';
import { searchTerms } from "../../../../constants";

export const IncDecProducers = ({
    currentTabId,
    minGrowth,
    maxGrowth,
    minLabel,
    maxLabel,
    minDefault,
    maxDefault,
    onMinInputChange,
    onMaxInputChange,
    onSelectorChange,
    selectorDefault,
    selectedMlsId,
    validationMessage,
    isGrowthAnalysisView,
    handleFilterChange,
    mlsOptions,
    selectedFilterValues,
}) => {
    const timeFrameOptions = isGrowthAnalysisView ? growthAnalysisIncDecTimeFrame : producerOptions.timeFrame;
    return (
        <>
            <FilterSelector
                containerClass='mb-3'
                dataLwtId='select-producers-mls'
                defaultValue={mlsOptions.find(mls => mls.value === selectedMlsId)}
                labelText={searchTerms.mls}
                options={mlsOptions}
                onChange={(option) => handleFilterChange(option, filterIds.producers, sfState.mls)}
                value={mlsOptions.find(mls => mls.value === (selectedFilterValues?.mls?.value ?? selectedMlsId))}
            />
            <div className='d-flex align-items-center justify-content-between'>
                <FilterInput
                    className={'pr-3'}
                    currentTabId={currentTabId}
                    dataLwtId='input-producers-min-value'
                    labelText={`${minLabel} %`}
                    defaultValue={minDefault}
                    onChange={onMinInputChange}
                    value={minGrowth}
                />
                <FilterInput
                    dataLwtId='input-producers-max-value'
                    currentTabId={currentTabId}
                    labelText={`${maxLabel} %`}
                    defaultValue={maxDefault}
                    onChange={onMaxInputChange}
                    value={maxGrowth}
                />
            </div>
            {!!validationMessage && <div className="text-danger mb-4 validation-text-wrapper" >{validationMessage}</div>}
            <FilterSelector
                dataLwtId='select-producers-time-frame'
                defaultValue={selectorDefault}
                labelText={terms.timeFrame}
                options={timeFrameOptions}
                onChange={onSelectorChange}
            />
        </>
    )
};

IncDecProducers.propTypes = {
    currentTabId: PropTypes.string.isRequired,
    minGrowth: PropTypes.any,
    maxGrowth: PropTypes.any,
    maxGrowthValue: PropTypes.any,
    minGrowthValue: PropTypes.any,
    minLabel: PropTypes.string,
    maxLabel: PropTypes.string,
    minDefault: PropTypes.any,
    maxDefault: PropTypes.any,
    onMinInputChange: PropTypes.func.isRequired,
    onMaxInputChange: PropTypes.func.isRequired,
    onSelectorChange: PropTypes.func.isRequired,
    selectorDefault: PropTypes.object,
    validationMessage: PropTypes.string,
    isGrowthAnalysisView: PropTypes.bool.isRequired,
};
